import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { ImlcExclusionStatesService } from '../../../js/api';

export const IMLC_EXCLUSION_STATES_QUERY_KEY = 'imlcExclusionStates';

export const useIMLCExclusionStates = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: [IMLC_EXCLUSION_STATES_QUERY_KEY],
    queryFn: () => ImlcExclusionStatesService.imlcExclusionStatesList(),
    staleTime: Infinity,
    cacheTime: 24 * 60 * 60 * 1000,
  });

  const excludedStateCodes = useMemo(
    () => new Set((data || []).map((entry) => entry.state_code)),
    [data]
  );

  return {
    excludedStateCodes,
    isLoading,
    error,
  };
};
